import { CustomPart, CustomWork } from "@tm/models"
import { CustomArticleItemResponse, CustomRepairTimeItemResponse } from "@tm/data/basket"

export function mapCustomArticleItemToCustomPart(article: CustomArticleItemResponse, quantity: number, memo: string | undefined): CustomPart {
    const { articleNumber, retailPrice, purchasePrice, description, vatRates } = article
    const selectedVatRate = vatRates?.find((vatRate) => vatRate.isSelected)
    return {
        articleNumber,
        retailPrice,
        purchasePrice,
        description,
        quantityValue: quantity,
        memo,
        vatRate: selectedVatRate
            ? {
                  vatRate: selectedVatRate.vatValue,
                  vatType: selectedVatRate.vatType,
              }
            : undefined,
    }
}

export function mapCustomRepairTimeItemToCustomWork(repairTime: CustomRepairTimeItemResponse): CustomWork {
    const { workId, category, description, workTime, customHourlyRate, fixedPriceValue, vatRates } = repairTime
    const selectedVatRate = vatRates?.find((vatRate) => vatRate.isSelected)
    return {
        customWorkNumber: workId,
        categoryOfWork: category,
        description,
        time: workTime,
        hourlyRate: customHourlyRate,
        fixedPriceValue,
        vatRate: selectedVatRate
            ? {
                  vatRate: selectedVatRate.vatValue,
                  vatType: selectedVatRate.vatType,
              }
            : undefined,
    }
}
